import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, StrictEffect, takeLatest } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";

import { performDataAction } from "@/services/api";

import {
    linkDocumentFailure,
    LinkDocumentPayload,
    linkDocumentSuccess
} from "./linkDocument";

function* linkDocumentSaga(
  action: PayloadAction<LinkDocumentPayload>
): Generator<StrictEffect, void, any> {
  const { companyId, transactionId, documentId } = action.payload;
  
  try {
    yield call(
      performDataAction,
      DataType.CommunicationsQuery,
      "update",
      { 
        companyId: companyId,
        query_id: documentId
      },
      {},
      {
        linked_document_id: transactionId
      }
    );

    yield put(linkDocumentSuccess());
  } catch (error) {
    yield put(linkDocumentFailure(extractError(error)));
  }
}

export default function* linkDocumentSagaWatcher() {
  yield takeLatest("linkDocument/linkDocument", linkDocumentSaga);
}